import { render, staticRenderFns } from "./globalErrorModalComponent.vue?vue&type=template&id=038fef6e"
import script from "./globalErrorModalComponent.vue?vue&type=script&lang=js"
export * from "./globalErrorModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports